export default __webpack_public_path__ + "static/media/buscar.e9930bee.svg";